(function () {
  if (typeof customElements === 'undefined') return;

  customElements.whenDefined('product-card').then(function () {
    var Proto = customElements.get('product-card').prototype;
    Proto.previewImage = function () {};
    Proto.resetImage = function () {};
    Proto.previewVariant = function () {};
    Proto.resetVariant = function () {};

    Proto.updatePrice = function (event) {
      try {
        var html = event && event.detail && event.detail.data && event.detail.data.html;
        if (!html) return;
        var priceContainer = this.querySelector('product-price [ref="priceContainer"]');
        var newPriceElement = html.querySelector('product-price [ref="priceContainer"]');
        if (newPriceElement && priceContainer) {
          priceContainer.innerHTML = newPriceElement.innerHTML;
        }
      } catch (e) { }
    };
  });

  function initVariantSwapFix() {
    document.querySelectorAll('product-card .card-gallery slideshow-component').forEach(function (ss) {
      var variantSlides = ss.querySelectorAll('slideshow-slide[variant-image]');
      if (variantSlides.length === 0) return;
      if (ss.dataset.tkVariantFix) return;
      ss.dataset.tkVariantFix = '1';

      var allSlides = ss.querySelectorAll('slideshow-slide');

      function syncSlides() {
        var activeVariant = null;
        variantSlides.forEach(function (vs) {
          if (!vs.hidden && !activeVariant) activeVariant = vs;
        });
        if (activeVariant) {
          allSlides.forEach(function (s) {
            s.setAttribute('aria-hidden', s === activeVariant ? 'false' : 'true');
          });
        } else {
          allSlides.forEach(function (s, i) {
            s.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
          });
        }
      }

      syncSlides();
      var observer = new MutationObserver(syncSlides);
      variantSlides.forEach(function (vs) {
        observer.observe(vs, { attributes: true, attributeFilter: ['hidden'] });
      });
    });
  }

  function initBadgeUpdate() {}

  var tkImageDataCache = window.__tkImageDataCache || new Map();
  window.__tkImageDataCache = tkImageDataCache;

  function getTargetVariantId(card, data) {
    var synced = card.getAttribute('data-tk-variant-synced');
    if (synced && data && data.v && data.v[synced]) return synced;
    var selSw = card.querySelector('.tk-card-swatch.is-selected');
    if (selSw && selSw.dataset.tkVariantId && data && data.v && data.v[selSw.dataset.tkVariantId]) {
      return selSw.dataset.tkVariantId;
    }
    if (card._tkInitialPreferApplied) {
      var nativeChecked = card.querySelector(
        'swatches-variant-picker-component input[type="radio"][name*="-swatch"]:checked[data-variant-id]'
      );
      if (nativeChecked && data && data.v && data.v[nativeChecked.dataset.variantId]) {
        return nativeChecked.dataset.variantId;
      }
    }
    var stored = card.getAttribute('data-selected-variant-id');
    if (stored && data && data.v && data.v[stored]) return stored;
    if (data && data.preferVariantId && data.v && data.v[data.preferVariantId]) {
      return data.preferVariantId;
    }
    if (data && data.v) {
      var k = Object.keys(data.v);
      if (k.length) return k[0];
    }
    return null;
  }

  function tkSwapImgFlashFree(imgEl, newSrc) {
    if (!imgEl || !newSrc) return;
    var apply = function () {
      imgEl.removeAttribute('srcset');
      imgEl.src = newSrc;
    };
    var pre = new Image();
    var done = false;
    var swap = function () { if (done) return; done = true; apply(); };
    pre.onload = swap;
    pre.onerror = swap;
    pre.src = newSrc;
    if (pre.complete && pre.naturalWidth > 0) swap();
  }

  function renderTargetVariant(card, targetVid, variantData) {
    if (!targetVid || !variantData) return;

    var targetSwatch = card.querySelector('.tk-card-swatch[data-tk-variant-id="' + targetVid + '"]');
    if (targetSwatch && !targetSwatch.classList.contains('is-selected')) {
      card.querySelectorAll('.tk-card-swatch.is-selected').forEach(function (s) {
        s.classList.remove('is-selected');
      });
      targetSwatch.classList.add('is-selected');
    }

    var displayedVid = card.getAttribute('data-tk-displayed-vid');
    if (String(displayedVid) === String(targetVid)) return;

    var hasNativePicker = !!card.querySelector('swatches-variant-picker-component');
    if (!hasNativePicker && variantData.imgs && variantData.imgs.length > 0) {
      var imgEl = card.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image')
               || card.querySelector('slideshow-slide:first-child img.product-media__image')
               || card.querySelector('img.product-media__image');
      if (imgEl) {
        var targetSrc = variantData.imgs[0];
        var currentSrc = imgEl.src || '';
        var currentBase = currentSrc.split('?')[0];
        var targetBase = targetSrc.split('?')[0];
        if (currentBase !== targetBase) {
          tkSwapImgFlashFree(imgEl, targetSrc);
        }
      }
    }

    if (variantData.price) {
      var priceContainer = card.querySelector('product-price [ref="priceContainer"]')
                        || card.querySelector('product-price > div')
                        || card.querySelector('product-price');
      if (priceContainer) {
        var labels = window.__tkPriceLabels || {};
        var lblReg = labels.regular || 'Regular price';
        var lblSale = labels.sale || 'Sale price';
        var badgeHtml = '';
        if (variantData.compareAtRaw && variantData.priceRaw && variantData.compareAtRaw > variantData.priceRaw) {
          var pct = Math.round((variantData.compareAtRaw - variantData.priceRaw) * 100 / variantData.compareAtRaw);
          badgeHtml = '<span class="price-discount-badge">-' + pct + '%</span>';
        }
        var newHtml;
        if (variantData.compareAt) {
          newHtml =
            '<span role="group"><span class="visually-hidden">' + lblReg + '&nbsp;</span><span class="compare-at-price">' + variantData.compareAt + '</span></span>' +
            '<span role="group"><span class="visually-hidden">' + lblSale + '&nbsp;</span><span class="price">' + variantData.price + '</span></span>' +
            badgeHtml;
        } else {
          newHtml = '<span class="price">' + variantData.price + '</span>';
        }
        priceContainer.innerHTML = newHtml;
      }
    }

    var nativeRadio = card.querySelector(
      'swatches-variant-picker-component input[type="radio"][data-variant-id="' + targetVid + '"]'
    );
    if (nativeRadio && !nativeRadio.checked) {
      nativeRadio.checked = true;
      var doDispatch = function () {
        if (!nativeRadio.checked) return;
        nativeRadio.dispatchEvent(new Event('change', { bubbles: true }));
      };
      if (window.customElements && window.customElements.whenDefined) {
        window.customElements
          .whenDefined('swatches-variant-picker-component')
          .then(doDispatch, function () {});
      } else {
        doDispatch();
      }
      var productLink = card.querySelector('.product-card__link');
      if (productLink && productLink.href) {
        try {
          var u = new URL(productLink.href, window.location.origin);
          u.searchParams.set('variant', targetVid);
          productLink.href = u.toString();
        } catch (e) { }
      }
    }

    card.setAttribute('data-tk-displayed-vid', String(targetVid));
    card._tkInitialPreferApplied = true;

    if (card._tkVariantData) updateDiscountPillForVariant(card, card._tkVariantData, targetVid);
  }

  function buildRatingBadgeHtml(data) {
    var scale = data.rating_scale > 0 ? data.rating_scale : 5;
    var pct = Math.max(0, Math.min(100, ((data.rating || 0) / scale) * 100));
    var star = '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M31.547 12a.848.848 0 00-.677-.577l-9.427-1.376-4.224-8.532a.847.847 0 00-1.516 0l-4.218 8.534-9.427 1.355a.847.847 0 00-.467 1.467l6.823 6.664-1.612 9.375a.847.847 0 001.23.893l8.428-4.434 8.432 4.432a.847.847 0 001.229-.894l-1.615-9.373 6.822-6.665a.845.845 0 00.214-.869z"/></svg>';
    var stars = star + star + star + star + star;
    return '<div class="tk-rating-badge">'
      + '<span class="tk-rating-badge__stars" aria-hidden="true">'
      + '<span class="tk-rating-badge__row tk-rating-badge__row--bg">' + stars + '</span>'
      + '<span class="tk-rating-badge__row tk-rating-badge__row--fill" style="width: ' + pct.toFixed(1) + '%;">' + stars + '</span>'
      + '</span>'
      + '</div>';
  }

  function removeSwatchSkeleton(card) {
    if (!card) return;
    var sk = card.querySelector('.tk-card-swatches--skeleton[data-tk-swatch-skeleton]');
    if (sk) sk.parentNode && sk.parentNode.removeChild(sk);
  }

  function addSwatchGhost(card) {
    if (!card) return;
    if (card.querySelector('.tk-card-swatches')) return;
    var bottomRow = card.querySelector('.tk-card-bottom-row');
    var ghost = document.createElement('div');
    ghost.className = 'tk-card-swatches tk-card-swatches--skeleton';
    ghost.setAttribute('data-tk-swatch-skeleton', '');
    ghost.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 3; i++) {
      var dot = document.createElement('span');
      dot.className = 'tk-card-swatch tk-card-swatch--skeleton';
      ghost.appendChild(dot);
    }
    if (bottomRow && bottomRow.parentNode) bottomRow.parentNode.insertBefore(ghost, bottomRow);
    else card.appendChild(ghost);
  }

  function applyVariantImages(card, data) {
    if (!data || !data.v) return;
    removeSwatchSkeleton(card);
    card._tkVariantData = data;
    if (data.label_regular || data.label_sale) {
      window.__tkPriceLabels = window.__tkPriceLabels || {};
      if (data.label_regular) window.__tkPriceLabels.regular = data.label_regular;
      if (data.label_sale) window.__tkPriceLabels.sale = data.label_sale;
    }
    var swatches = card.querySelectorAll('.tk-card-swatch[data-tk-swatch]');
    swatches.forEach(function (sw) {
      var vid = sw.dataset.tkVariantId;
      var v = data.v[vid];
      if (!v) return;
      if (v.price) sw.dataset.tkVariantPrice = v.price;
      if (v.compareAt) sw.dataset.tkVariantCompare = v.compareAt;
      if (v.imgs && v.imgs.length > 0) {
        sw.dataset.tkVariantImage = v.imgs[0];
        var existingImg = sw.querySelector('img');
        if (!existingImg) {
          var img = document.createElement('img');
          img.alt = v.name || '';
          img.loading = 'lazy';
          img.addEventListener('load', function () { this.classList.add('is-loaded'); var tksw = this.closest('.tk-card-swatch'); if (tksw) tksw.classList.add('tk-card-swatch--loaded'); }, { once: true });
          img.addEventListener('error', function () { this.classList.add('is-loaded'); var tksw = this.closest('.tk-card-swatch'); if (tksw) tksw.classList.add('tk-card-swatch--loaded'); }, { once: true });
          img.src = v.imgs[0];
          if (img.complete && img.naturalWidth > 0) img.classList.add('is-loaded');
          sw.classList.add('tk-card-swatch--loaded');
          sw.appendChild(img);
        } else if (!existingImg.classList.contains('is-loaded')) {
          if (existingImg.complete && existingImg.naturalWidth > 0) {
            existingImg.classList.add('is-loaded');
            var tksw2 = existingImg.closest('.tk-card-swatch');
            if (tksw2) tksw2.classList.add('tk-card-swatch--loaded');
          } else {
            existingImg.addEventListener('load', function () { this.classList.add('is-loaded'); var tksw = this.closest('.tk-card-swatch'); if (tksw) tksw.classList.add('tk-card-swatch--loaded'); }, { once: true });
            existingImg.addEventListener('error', function () { this.classList.add('is-loaded'); var tksw = this.closest('.tk-card-swatch'); if (tksw) tksw.classList.add('tk-card-swatch--loaded'); }, { once: true });
          }
        }
      }
    });

    if (data.rating_count > 0 || (data.rating_count === undefined && data.badge_html)) {
      var rating = card.querySelector('.tk-card-rating');
      if (rating && !rating.dataset.tkBadgeFilled) {
        rating.innerHTML = data.rating_count !== undefined
          ? buildRatingBadgeHtml(data)
          : data.badge_html;
        rating.dataset.tkBadgeFilled = '1';
      }
    }

    if (data.badges_html) {
      var tkBadgesTarget = card.querySelector('.product-badges');
      if (tkBadgesTarget && !tkBadgesTarget.querySelector('.tk-badges')) {
        tkBadgesTarget.insertAdjacentHTML('beforeend', data.badges_html);
      }
    }

    card.querySelectorAll('.product-badges__badge--sale').forEach(function (b) { b.remove(); });

    if (data.sale_ended) {
      var notifyCta = card.querySelector('.tk-card-atc--notify, .quick-add__button--notify');
      if (notifyCta) {
        var endedEl = document.createElement('span');
        endedEl.className = 'tk-card-atc tk-card-atc--sale-ended';
        endedEl.textContent = data.sale_ended_label || (window.tkI18n && window.tkI18n.card_sale_ended) || '';
        notifyCta.replaceWith(endedEl);
      }
    }

    var targetVid = getTargetVariantId(card, data);
    if (targetVid && data.v[targetVid]) {
      renderTargetVariant(card, targetVid, data.v[targetVid]);
    }

    renderDiscountPill(card, data, targetVid);

    injectSiblingSwatches(card, data);
  }

  function showSwatchContainer(card) {
    var container = card.querySelector('.tk-card-swatches');
    if (!container || container.classList.contains('is-loaded')) return;
    var imgs = Array.from(container.querySelectorAll('img'));
    if (imgs.length === 0) {
      container.classList.add('is-loaded');
      return;
    }
    var pending = imgs.length;
    var done = function () { if (--pending <= 0) container.classList.add('is-loaded'); };
    setTimeout(function () {
      if (!container.classList.contains('is-loaded')) container.classList.add('is-loaded');
    }, 1500);
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) done();
      else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
  }

  function cardHasVisibleColorSwatches(card) {
    if (!card) return false;
    if (card.querySelector('.tk-card-swatch[data-tk-variant-id]')) return true;
    if (card.querySelector('.tk-mini-swatch[href*="variant="]')) return true;
    var ps = card.querySelector('product-swatches');
    if (ps && (ps.children.length > 0 || ps.querySelector('input, swatch-element, a, button'))) return true;
    return false;
  }

  function getCardAtcMode(card) {
    if (!card) return 'add';
    if (card.querySelector('.tk-card-atc--sold-out, .tk-card-atc--notify')) return 'sold_out';
    if (card.querySelector('.quick-add__button[disabled], .quick-add__button--notify')) return 'sold_out';
    if (cardHasVisibleColorSwatches(card)) return 'add';
    if (card.querySelector('.tk-card-atc--choose, .quick-add__button--choose')) return 'choose';
    return 'add';
  }

  function resolveCardVariantId(card) {
    if (!card) return null;
    var hidden = card.querySelector('quick-add-component input[name="id"]');
    if (hidden && hidden.value && !hidden.hasAttribute('disabled')) return hidden.value;
    var v = card.getAttribute('data-tk-displayed-vid');
    if (v) return v;
    var sel = card.querySelector('.tk-card-swatch.is-selected[data-tk-variant-id]');
    if (sel) return sel.getAttribute('data-tk-variant-id');
    v = card.getAttribute('data-selected-variant-id');
    if (v) return v;
    var atc = card.querySelector('[data-tk-card-atc][data-variant-id]');
    if (atc) return atc.getAttribute('data-variant-id');
    var checked = card.querySelector('product-swatches input[type="radio"]:checked');
    if (checked && checked.value && /^\d+$/.test(checked.value)) return checked.value;
    var qBtn = card.querySelector('.quick-add__button[data-variant-id]');
    if (qBtn) return qBtn.getAttribute('data-variant-id');
    return null;
  }

  function buildPillCopy(price, percent, code) {
    var frame = (window.tkI18n && window.tkI18n.card_discount_pill) || 'Buy for %PRICE% with %PERCENT% discount code %CODE%';
    var lang = (document.documentElement.getAttribute('lang') || 'cs').toLowerCase();
    var pct = lang.indexOf('en') === 0 ? percent + '%' : percent + ' %';
    return frame
      .replace('%PRICE%', '<strong>' + price + '</strong>')
      .replace('%PERCENT%', '<strong>' + pct + '</strong>')
      .replace('%CODE%', '<span class="tk-card-discount__code">' + code + '</span>');
  }

  function renderDiscountPill(card, data, targetVid) {
    if (!card || !data) return;
    if (!data.discountCode || !data.discountPercent) return;
    if (getCardAtcMode(card) === 'sold_out') return;
    if (card._tkDiscountPillRendered) {
      updateDiscountPillForVariant(card, data, targetVid);
      return;
    }

    var vid = targetVid || getTargetVariantId(card, data);
    if (!vid || !data.v[vid]) return;
    var variant = data.v[vid];
    if (!variant.discountedPrice) return;
    var modeForVariant = getCardAtcMode(card);
    if (modeForVariant === 'add' && variant.available === false) return;

    var bottomRow = card.querySelector('.tk-card-bottom-row');
    var swatches = card.querySelector('.tk-card-swatches') || card.querySelector('product-swatches');

    var insertParent = null;
    var insertBefore = null;
    if (bottomRow) {
      insertParent = bottomRow.parentNode;
      insertBefore = bottomRow;
    } else if (swatches && swatches.parentNode) {
      insertParent = swatches.parentNode;
      insertBefore = swatches.nextSibling;
    } else {
      var groupContent = card.querySelector('.group-block-content');
      if (groupContent) {
        insertParent = groupContent;
        insertBefore = null;
      } else {
        return;
      }
    }

    var pill = document.createElement('a');
    pill.className = 'tk-card-discount';
    pill.setAttribute('data-tk-card-discount', '1');
    pill.setAttribute('data-discount-code', data.discountCode);
    pill.setAttribute('data-product-url', data.productUrl || '');
    pill.setAttribute('rel', 'nofollow');
    pill.href = '/discount/' + encodeURIComponent(data.discountCode)
              + '?redirect=' + encodeURIComponent(data.productUrl || window.location.pathname);

    var iconHtml = '<span class="tk-card-discount__icon" aria-hidden="true">'
      + '<svg viewBox="0 0 16 16" width="11" height="11" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'
      + '<path d="M8.5 1.5h5.5a1 1 0 0 1 1 1v5.5L8 14.5 1.5 8 8.5 1.5Z"/>'
      + '<circle cx="11" cy="5" r="1" fill="currentColor" stroke="none"/>'
      + '</svg></span>';
    var labelHtml = '<span class="tk-card-discount__text">'
      + buildPillCopy(variant.discountedPrice, data.discountPercent, data.discountCode)
      + '</span>';
    pill.innerHTML = iconHtml + labelHtml;

    if (insertBefore) insertParent.insertBefore(pill, insertBefore);
    else insertParent.appendChild(pill);
    var tkPrev = pill.previousElementSibling;
    if (tkPrev && tkPrev.classList.contains('tk-card-swatches')) tkPrev.classList.add('tk-card-swatches--before-discount');

    card._tkDiscountPillRendered = true;
  }

  function updateDiscountPillForVariant(card, data, targetVid) {
    if (!card || !data || !data.discountCode || !data.discountPercent) return;
    var pill = card.querySelector('.tk-card-discount');
    if (!pill) {
      renderDiscountPill(card, data, targetVid);
      return;
    }
    if (!targetVid || !data.v[targetVid]) return;
    var variant = data.v[targetVid];
    if (!variant.discountedPrice) return;
    var mode = getCardAtcMode(card);
    if (mode === 'add' && variant.available === false) {
      pill.style.display = 'none';
    } else {
      pill.style.display = '';
    }
    var textEl = pill.querySelector('.tk-card-discount__text');
    if (textEl) {
      textEl.innerHTML = buildPillCopy(variant.discountedPrice, data.discountPercent, data.discountCode);
    }
  }

  function handleDiscountPillClick(e, pill) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    e.stopPropagation();

    if (pill.dataset.tkBusy === '1') return;

    var card = pill.closest('product-card');
    var code = pill.getAttribute('data-discount-code');
    var productUrl = pill.getAttribute('data-product-url');
    if (!code) return;

    var currentPath = window.location.pathname + window.location.search;
    pill.dataset.tkBusy = '1';
    pill.classList.add('is-loading');

    var mode = card ? getCardAtcMode(card) : 'add';

    if (mode === 'choose' || mode === 'sold_out') {
      var redirectPdp = productUrl || currentPath;
      window.location.href = '/discount/' + encodeURIComponent(code)
        + '?redirect=' + encodeURIComponent(redirectPdp);
      return;
    }

    var variantId = resolveCardVariantId(card);

    if (!variantId) {
      var fallback = productUrl || currentPath;
      window.location.href = '/discount/' + encodeURIComponent(code)
        + '?redirect=' + encodeURIComponent(fallback);
      return;
    }

    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    }).then(function (r) {
      return r.json().then(function (body) { return { ok: r.ok, body: body }; });
    }).then(function (res) {
      if (!res.ok || (res.body && res.body.status)) {
        pill.classList.remove('is-loading');
        pill.dataset.tkBusy = '';
        var msg = (res.body && (res.body.description || res.body.message)) || ((window.tkI18n && window.tkI18n.cart_add_error) || 'Error adding to cart');
        showAtcToast(msg);
        return;
      }
      try { sessionStorage.setItem('tk_discount_atc_pending', '1'); } catch (err) {}
      window.location.href = '/discount/' + encodeURIComponent(code)
        + '?redirect=' + encodeURIComponent(currentPath);
    }).catch(function (err) {
      pill.classList.remove('is-loading');
      pill.dataset.tkBusy = '';
      showAtcToast(((window.tkI18n && window.tkI18n.cart_add_error) || 'Error adding to cart'));
      if (window.console) console.error('[tk-card-discount]', err);
    });
  }

  function initDiscountPillClicks() {
    if (window.__tkCardDiscountInit) return;
    window.__tkCardDiscountInit = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var pill = t.closest('[data-tk-card-discount]');
      if (!pill) return;
      handleDiscountPillClick(e, pill);
    }, true);
  }

  function openCartDrawerFromFlag() {
    try {
      if (sessionStorage.getItem('tk_discount_atc_pending') !== '1') return;
      sessionStorage.removeItem('tk_discount_atc_pending');
    } catch (e) { return; }

    var tries = 0;
    function tryOpen() {
      tries++;
      var drawer = document.querySelector('cart-drawer-component#MoCartDrawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      var trig = document.querySelector('[data-tk-cart-trigger]');
      if (trig) { trig.click(); return; }
      if (tries < 30) setTimeout(tryOpen, 100);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(tryOpen, 80); });
    } else {
      setTimeout(tryOpen, 80);
    }
  }

  function getCardHandle(card) {
    if (!card) return null;
    var firstSw = card.querySelector('.tk-card-swatch[data-tk-swatch]');
    if (firstSw && firstSw.dataset.tkVariantUrl) {
      var m1 = firstSw.dataset.tkVariantUrl.match(/\/products\/([^?]+)/);
      if (m1) return m1[1];
    }
    var link = card.querySelector('a[href*="/products/"]');
    if (link) {
      var m2 = link.getAttribute('href').match(/\/products\/([^?#]+)/);
      if (m2) return m2[1];
    }
    return null;
  }

  var TK_VI_TTL = 15 * 60 * 1000;
  function readViCache(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ts || Date.now() - obj.ts > TK_VI_TTL) {
        sessionStorage.removeItem(key);
        return null;
      }
      return obj.d;
    } catch (e) { return null; }
  }
  function writeViCache(key, data) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), d: data }));
    } catch (e) { }
  }

  var tkEmbedIngested = false;
  function ingestEmbeddedSwatchData() {
    if (tkEmbedIngested) return;
    var el = document.getElementById('tk-swatch-data-embed');
    if (!el) return;
    tkEmbedIngested = true;
    var map;
    try { map = JSON.parse(el.textContent.trim()); } catch (e) { return; }
    if (!map || typeof map !== 'object') return;
    var tkRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var tkCountry = (window.__tkCountry || (window.Shopify && window.Shopify.country) || '');
    Object.keys(map).forEach(function (handle) {
      var data = map[handle];
      if (!data) return;
      if (!tkImageDataCache.has(handle)) {
        tkImageDataCache.set(handle, Promise.resolve(data));
      }
      writeViCache('tk_vi:' + tkRoot + ':' + tkCountry + ':' + handle, data);
    });
  }

  function fetchVariantImagesOnce(card) {
    if (!card) return Promise.resolve();
    var handle = getCardHandle(card);
    if (!handle) return Promise.resolve();

    if (!tkImageDataCache.has(handle)) {
      var tkRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var tkCountry = (window.__tkCountry || (window.Shopify && window.Shopify.country) || '');
      var cacheKey = 'tk_vi:' + tkRoot + ':' + tkCountry + ':' + handle;
      var cached = readViCache(cacheKey);
      if (cached) {
        tkImageDataCache.set(handle, Promise.resolve(cached));
      } else {
        var p = fetch(tkRoot + 'products/' + handle + '?section_id=tk-variant-images' + (tkCountry ? '&country=' + tkCountry : ''))
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return null;
            var div = document.createElement('div');
            div.innerHTML = html;
            var section = div.querySelector('.shopify-section');
            if (!section) return null;
            try {
              var data = JSON.parse(section.textContent.trim());
              if (data) writeViCache(cacheKey, data);
              return data;
            } catch (e) { return null; }
          })
          .catch(function () { return null; });
        tkImageDataCache.set(handle, p);
      }
    }

    return tkImageDataCache.get(handle).then(function (data) {
      if (data) applyVariantImages(card, data);
      removeSwatchSkeleton(card);
      showSwatchContainer(card);
    });
  }

  var tkSwatchIO = null;
  function getSwatchIO() {
    if (tkSwatchIO) return tkSwatchIO;
    if (typeof IntersectionObserver === 'undefined') return null;
    tkSwatchIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          fetchVariantImagesOnce(entry.target);
          tkSwatchIO.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });
    return tkSwatchIO;
  }

  function initSwatchClicks() {
    document.querySelectorAll('product-card.product-card').forEach(function (card) {
      if (card._tkImagesQueued) return;
      card._tkImagesQueued = true;
      fetchVariantImagesOnce(card);
    });

    document.querySelectorAll('.tk-card-swatch[data-tk-swatch]').forEach(function (sw) {
      if (sw.dataset.tkSwatchInit === '1') return;
      sw.dataset.tkSwatchInit = '1';

      sw.addEventListener('click', function (e) {
        if (sw.classList.contains('is-selected')) return;
        e.preventDefault();
        e.stopPropagation();

        var card = sw.closest('product-card.product-card') || sw.closest('.product-card');
        if (!card) return;

        var doSwap = function () { performVariantSwap(card, sw); };
        if (!sw.dataset.tkVariantImage || sw.dataset.tkVariantImage === '') {
          fetchVariantImagesOnce(card).then(doSwap);
        } else {
          doSwap();
        }
      });
    });

    initSiblingSwatchHandler();
  }

  function performVariantSwap(card, sw) {
        var newImg = sw.dataset.tkVariantImage;
        var newPrice = sw.dataset.tkVariantPrice;
        var newCompare = sw.dataset.tkVariantCompare;
        var newUrl = sw.dataset.tkVariantUrl;
        var newVariantId = sw.dataset.tkVariantId;
        var vd = card._tkVariantData && card._tkVariantData.v && card._tkVariantData.v[newVariantId];
        if (vd) { if (vd.price) newPrice = vd.price; newCompare = vd.compareAt || ''; }

        var imgEl = card.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image')
                 || card.querySelector('slideshow-slide:first-child img.product-media__image')
                 || card.querySelector('img.product-media__image');
        if (newImg && imgEl) {
          tkSwapImgFlashFree(imgEl, newImg);
        }

        var priceContainer = card.querySelector('product-price > div')
                          || card.querySelector('product-price');
        if (priceContainer && newPrice) {
          if (newCompare && newCompare.trim() !== '') {
            var lblReg = (window.__tkPriceLabels && window.__tkPriceLabels.regular) || 'Regular price';
            var lblSale = (window.__tkPriceLabels && window.__tkPriceLabels.sale) || 'Sale price';
            var vpRaw = parseFloat(sw.dataset.tkVariantPriceRaw);
            var vcRaw = parseFloat(sw.dataset.tkVariantCompareRaw);
            var vBadge = '';
            if (vcRaw && vpRaw && vcRaw > vpRaw) {
              vBadge = '<span class="price-discount-badge">-' + Math.round((vcRaw - vpRaw) * 100 / vcRaw) + '%</span>';
            }
            priceContainer.innerHTML =
              '<span role="group"><span class="visually-hidden">' + lblReg + '&nbsp;</span><span class="compare-at-price">' + newCompare + '</span></span>' +
              '<span role="group"><span class="visually-hidden">' + lblSale + '&nbsp;</span><span class="price">' + newPrice + '</span></span>' +
              vBadge;
          } else {
            priceContainer.innerHTML = '<span class="price">' + newPrice + '</span>';
          }
        }

        var vExistingSale = card.querySelector('.product-badges .product-badges__badge--sale');
        if (vExistingSale) vExistingSale.remove();

        if (newUrl) {
          card.querySelectorAll('a:not(.tk-card-swatch)').forEach(function (a) {
            a.href = newUrl;
          });
        }

        var wb = card.querySelector('wishlist-button.tk-wishlist-btn');
        if (wb) {
          wb.setAttribute('data-variant-id', newVariantId || '');
          if (newUrl) wb.setAttribute('data-url', newUrl);
          if (newImg) wb.setAttribute('data-image', newImg);
          if (newPrice) wb.setAttribute('data-price', newPrice);
        }
        var cb = card.querySelector('compare-button.tk-compare-btn');
        if (cb) {
          cb.setAttribute('data-variant-id', newVariantId || '');
          if (newUrl) cb.setAttribute('data-url', newUrl);
          if (newImg) cb.setAttribute('data-image', newImg);
        }

        var newVidNum = newVariantId ? parseInt(newVariantId, 10) : null;
        if (newVidNum) {
          card.dispatchEvent(new CustomEvent('variant:update', {
            bubbles: true,
            detail: {
              resource: {
                id: newVidNum,
                title: sw.getAttribute('aria-label') || '',
                url: newUrl || ''
              }
            }
          }));
        }

    card.querySelectorAll('.tk-card-swatch.is-selected').forEach(function (s) {
      s.classList.remove('is-selected');
    });
    sw.classList.add('is-selected');
  }

  function markSwatchImgLoaded(img) {
    if (!img) return;
    if (img.complete && img.naturalWidth > 0) { img.classList.add('is-loaded'); return; }
    img.addEventListener('load', function () { this.classList.add('is-loaded'); var tksw = this.closest('.tk-card-swatch'); if (tksw) tksw.classList.add('tk-card-swatch--loaded'); }, { once: true });
    img.addEventListener('error', function () { this.classList.add('is-loaded'); var tksw = this.closest('.tk-card-swatch'); if (tksw) tksw.classList.add('tk-card-swatch--loaded'); }, { once: true });
  }

  function setCardTitle(root, title) {
    if (!root || !title) return;
    var sels = ['.tk-mega-products__title', '.tk-mega__mini-product-title', '.resource-card__title',
                'a[ref="productTitleLink"] .text-block p', '.product-grid-view-zoom-out--details h3',
                '.group-block-content .text-block p'];
    var hit = false;
    sels.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (el) {
        if (el.textContent.trim() !== title) el.textContent = title;
        hit = true;
      });
    });
    if (!hit) {
      var el = root.querySelector('.text-block p');
      if (el && el.textContent.trim() !== title) el.textContent = title;
    }
  }

  function injectSiblingSwatches(card, data) {
    if (!card || !data || !data.siblings || data.siblings.length < 2) return;
    if (card._tkSiblingsInjected) return;
    if (card.querySelector('.tk-card-swatches--sibling')) { card._tkSiblingsInjected = true; return; }
    if (card.querySelector('.tk-card-swatch[data-tk-swatch]')) return;
    card._tkSiblingsInjected = true;

    var container = document.createElement('div');
    container.className = 'tk-card-swatches tk-card-swatches--sibling is-loaded';
    data.siblings.forEach(function (s) {
      if (!s || !s.vid) return;
      var sOnSale = s.available && s.compareAtRaw != null && s.priceRaw != null && s.compareAtRaw > s.priceRaw;
      var a = document.createElement('a');
      a.className = 'tk-card-swatch tk-card-swatch--sibling' + (s.current ? ' is-selected' : '') + (s.available ? '' : ' tk-card-swatch--soldout') + (sOnSale ? ' tk-card-swatch--has-sale' : '');
      a.href = s.url || '#';
      a.setAttribute('data-tk-sibling', '1');
      a.setAttribute('data-tk-variant-id', s.vid);
      a.setAttribute('data-tk-sibling-url', s.url || '');
      a.setAttribute('data-tk-sibling-image', s.image || '');
      a.setAttribute('data-tk-sibling-title', s.title || '');
      a.setAttribute('data-tk-sibling-price', s.price || '');
      a.setAttribute('data-tk-sibling-compare', s.compareAt || '');
      if (s.priceRaw != null) a.setAttribute('data-tk-sibling-price-raw', s.priceRaw);
      if (s.compareAtRaw != null) a.setAttribute('data-tk-sibling-compare-raw', s.compareAtRaw);
      a.setAttribute('data-tk-sibling-available', s.available ? 'true' : 'false');
      if (s.rezim) a.setAttribute('data-tk-sibling-rezim', s.rezim);
      a.setAttribute('aria-label', s.label || '');
      a.setAttribute('title', s.label || '');
      if (s.image) {
        var img = document.createElement('img');
        img.alt = s.label || '';
        img.loading = 'lazy';
        img.src = s.image.replace(/([?&]width=)800\b/, '$1120');
        markSwatchImgLoaded(img);
        a.appendChild(img);
      }
      if (sOnSale) {
        var saleBadge = document.createElement('span');
        saleBadge.className = 'tk-swatch-sale';
        saleBadge.setAttribute('aria-hidden', 'true');
        saleBadge.textContent = '%';
        a.appendChild(saleBadge);
      }
      container.appendChild(a);
    });

    var bottomRow = card.querySelector('.tk-card-bottom-row');
    if (bottomRow && bottomRow.parentNode) {
      bottomRow.parentNode.insertBefore(container, bottomRow);
    } else {
      var content = card.querySelector('.group-block-content') || card.querySelector('.product-card__content') || card;
      content.appendChild(container);
    }

    for (var ci = 0; ci < data.siblings.length; ci++) {
      var cs = data.siblings[ci];
      if (cs && cs.current && cs.title) { setCardTitle(card, cs.title); break; }
    }
  }

  function siblingMainImage(root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('img'));
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].closest('.tk-card-swatch')) return imgs[i];
    }
    return null;
  }

  function swapStockBadge(root, rezim) {
    var badge = root.querySelector('.tk-stock-badge[data-tk-stock]');
    if (!badge || !rezim || badge.getAttribute('data-tk-stock') === rezim) return;
    if (rezim === 'dodavatel') {
      var html = badge.getAttribute('data-tk-stock-supplier');
      if (!html) return;
      badge.innerHTML = html;
      badge.removeAttribute('aria-hidden');
    } else {
      var text = badge.getAttribute(rezim === 'vyprodano' ? 'data-tk-stock-out' : 'data-tk-stock-own');
      if (!text) return;
      badge.textContent = text;
      badge.setAttribute('aria-hidden', 'true');
    }
    badge.classList.toggle('tk-stock-badge--supplier', rezim === 'dodavatel');
    badge.classList.toggle('tk-stock-badge--out', rezim === 'vyprodano');
    badge.setAttribute('data-tk-stock', rezim);
  }

  function performSiblingSwap(root, sw) {
    var newImg = sw.getAttribute('data-tk-sibling-image');
    var newPrice = sw.getAttribute('data-tk-sibling-price');
    var newCompare = sw.getAttribute('data-tk-sibling-compare');
    var newUrl = sw.getAttribute('data-tk-sibling-url');
    var newTitle = sw.getAttribute('data-tk-sibling-title');
    var newVid = sw.getAttribute('data-tk-variant-id');
    var newAvail = sw.getAttribute('data-tk-sibling-available') === 'true';

    var imgEl = root.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image')
             || root.querySelector('slideshow-slide:first-child img.product-media__image')
             || siblingMainImage(root);
    if (newImg && imgEl) { tkSwapImgFlashFree(imgEl, newImg); }

    var priceContainer = root.querySelector('product-price [ref="priceContainer"]')
                      || root.querySelector('[ref="priceContainer"]')
                      || root.querySelector('product-price > div')
                      || root.querySelector('product-price');
    if (priceContainer && newPrice) {
      var labels = window.__tkPriceLabels || {};
      var lblReg = labels.regular || 'Regular price';
      var lblSale = labels.sale || 'Sale price';
      if (newCompare && newCompare.trim() !== '') {
        var pRaw = parseFloat(sw.getAttribute('data-tk-sibling-price-raw'));
        var cRaw = parseFloat(sw.getAttribute('data-tk-sibling-compare-raw'));
        var badge = '';
        if (cRaw && pRaw && cRaw > pRaw) {
          badge = '<span class="price-discount-badge">-' + Math.round((cRaw - pRaw) * 100 / cRaw) + '%</span>';
        }
        priceContainer.innerHTML =
          '<span role="group"><span class="visually-hidden">' + lblReg + '&nbsp;</span><span class="compare-at-price">' + newCompare + '</span></span>' +
          '<span role="group"><span class="visually-hidden">' + lblSale + '&nbsp;</span><span class="price">' + newPrice + '</span></span>' +
          badge;
      } else {
        priceContainer.innerHTML = '<span class="price">' + newPrice + '</span>';
      }
    } else if (newPrice) {
      var simplePrice = root.querySelector('.tk-mega-products__price')
                     || root.querySelector('.tk-mega__mini-product-price')
                     || root.querySelector('.tk-mobile-drawer__product-price')
                     || root.querySelector('.resource-card__content .price')
                     || root.querySelector('.price');
      if (simplePrice) {
        var baseCls = '';
        simplePrice.classList.forEach(function (c) {
          if (!baseCls && c.indexOf('--sale') === -1 && c.indexOf('tk-mega-price') === -1) baseCls = c;
        });
        var spRaw = parseFloat(sw.getAttribute('data-tk-sibling-price-raw'));
        var scRaw = parseFloat(sw.getAttribute('data-tk-sibling-compare-raw'));
        if (newCompare && newCompare.trim() !== '' && scRaw && spRaw && scRaw > spRaw) {
          var spPct = Math.round((scRaw - spRaw) * 100 / scRaw);
          simplePrice.innerHTML =
            '<span class="tk-mega-price__compare">' + newCompare + '</span>' +
            '<span class="tk-mega-price__current">' + newPrice + '</span>' +
            (spPct > 0 ? '<span class="tk-mega-price__badge">-' + spPct + '%</span>' : '');
          if (baseCls) simplePrice.classList.add(baseCls + '--sale');
        } else {
          simplePrice.innerHTML = newPrice;
          if (baseCls) simplePrice.classList.remove(baseCls + '--sale');
        }
      }
    }

    var existingSale = root.querySelector('.product-badges .product-badges__badge--sale');
    if (existingSale) existingSale.remove();

    if (newUrl) {
      root.querySelectorAll('a:not([data-tk-sibling])').forEach(function (a) { a.href = newUrl; });
    }

    if (newTitle) setCardTitle(root, newTitle);

    var atc = root.querySelector('[data-tk-card-atc]');
    if (atc) {
      atc.setAttribute('data-variant-id', newVid || '');
      atc.setAttribute('data-tk-variant-available', newAvail ? 'true' : 'false');
    }
    var hiddenId = root.querySelector('quick-add-component input[name="id"]');
    if (hiddenId && newVid) hiddenId.value = newVid;

    swapStockBadge(root, sw.getAttribute('data-tk-sibling-rezim'));

    var newVidNum = newVid ? parseInt(newVid, 10) : null;
    if (newVidNum) {
      root.dispatchEvent(new CustomEvent('variant:update', {
        bubbles: true,
        detail: { resource: { id: newVidNum, title: sw.getAttribute('aria-label') || '', url: newUrl || '' } }
      }));
    }

    root.querySelectorAll('.tk-card-swatch--sibling.is-selected').forEach(function (s) { s.classList.remove('is-selected'); });
    sw.classList.add('is-selected');
  }

  function initSiblingSwatchHandler() {
    document.querySelectorAll('.tk-card-swatch--sibling img:not(.is-loaded)').forEach(markSwatchImgLoaded);
    if (window.__tkSiblingSwatchInit) return;
    window.__tkSiblingSwatchInit = true;
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-tk-sibling]');
      if (!sw) return;
      if (sw.classList.contains('is-selected')) return;
      e.preventDefault();
      e.stopPropagation();
      var root = sw.closest('product-card.product-card') || sw.closest('.product-card')
              || sw.closest('.tk-mega-products__card') || sw.closest('.tk-mega__mini-product')
              || sw.closest('[data-tk-search-card]') || sw.closest('.resource-card');
      if (root) performSiblingSwap(root, sw);
    }, true);
  }

  function tkHoverSwap(card, sw) {
    if (sw.matches('[data-tk-sibling]')) performSiblingSwap(card, sw);
    else performVariantSwap(card, sw);
  }

  function swatchHoverRoot(el) {
    return el.closest('product-card.product-card') || el.closest('.product-card')
        || el.closest('.tk-mega-products__card') || el.closest('.tk-mega__mini-product')
        || el.closest('[data-tk-search-card]') || el.closest('.resource-card');
  }

  var tkWarmedCards = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function warmSwapImages(card) {
    if (!card || !tkWarmedCards || tkWarmedCards.has(card)) return;
    tkWarmedCards.add(card);
    card.querySelectorAll('[data-tk-sibling-image]').forEach(function (sw) {
      var u = sw.getAttribute('data-tk-sibling-image');
      if (u) { var im = new Image(); im.src = u; }
    });
    var handle = getCardHandle(card);
    if (handle && tkImageDataCache.has(handle)) {
      tkImageDataCache.get(handle).then(function (data) {
        if (!data || !data.v) return;
        card.querySelectorAll('.tk-card-swatch[data-tk-swatch]').forEach(function (sw) {
          var vid = sw.getAttribute('data-tk-variant-id');
          var v = vid && data.v[vid];
          if (v && v.imgs && v.imgs[0]) { var im = new Image(); im.src = v.imgs[0]; }
        });
      });
    }
  }

  function initSwatchHover() {
    if (window.__tkSwatchHoverInit) return;
    if (!(window.matchMedia && window.matchMedia('(hover: hover)').matches)) return;
    window.__tkSwatchHoverInit = true;

    var SW_SEL = '.tk-card-swatch[data-tk-swatch], .tk-card-swatch--sibling[data-tk-sibling]';

    function tkCardTitleEl(root) {
      return root.querySelector(
        '.text-block[class*="product_title"] p, .group-block-content > a .text-block p,'
          + ' .group-block-content .text-block.rte p, .tk-mega-products__title,'
          + ' .tk-mega__mini-product-title, .resource-card__title'
      );
    }
    function tkLockTitleHeight(root) {
      var el = tkCardTitleEl(root);
      if (!el || el._tkHLock) return;
      var cs = getComputedStyle(el);
      var lh = parseFloat(cs.lineHeight);
      if (!lh) return;
      var lines = Math.max(1, Math.round(el.getBoundingClientRect().height / lh));
      el._tkHLock = {
        clamp: el.style.webkitLineClamp || '',
        minH: el.style.minHeight || '',
        maxH: el.style.maxHeight || '',
      };
      if (cs.display === '-webkit-box') el.style.webkitLineClamp = String(lines);
      el.style.minHeight = lines * lh + 'px';
      el.style.maxHeight = lines * lh + 'px';
    }
    function tkUnlockTitleHeight(root) {
      var el = tkCardTitleEl(root);
      if (!el || !el._tkHLock) return;
      el.style.webkitLineClamp = el._tkHLock.clamp;
      el.style.minHeight = el._tkHLock.minH;
      el.style.maxHeight = el._tkHLock.maxH;
      el._tkHLock = null;
    }

    document.addEventListener('mouseover', function (e) {
      if (!e.target || !e.target.closest) return;
      var warmRoot = swatchHoverRoot(e.target);
      if (warmRoot) warmSwapImages(warmRoot);
      var sw = e.target.closest(SW_SEL);
      if (!sw) return;
      var group = sw.closest('.tk-card-swatches');
      if (!group) return;
      var card = swatchHoverRoot(group);
      if (!card) return;
      if (group._tkShown === sw) return;
      if (!group._tkHoverDefault) {
        group._tkHoverDefault = group.querySelector('.tk-card-swatch.is-selected')
                             || group.querySelector('.tk-card-swatch');
      }
      tkLockTitleHeight(card);
      group._tkShown = sw;
      tkHoverSwap(card, sw);
    });

    document.addEventListener('mouseout', function (e) {
      if (!e.target || !e.target.closest) return;
      var group = e.target.closest('.tk-card-swatches');
      if (!group || !group._tkShown) return;
      var to = e.relatedTarget;
      if (to && group.contains(to)) return;
      var card = swatchHoverRoot(group);
      if (!card) return;
      var def = group._tkHoverDefault;
      group._tkShown = null;
      if (def) tkHoverSwap(card, def);
      tkUnlockTitleHeight(card);
    });
  }

  window.TKReapplyCardVariant = function (card) {
    if (!card) return;
    var handle = getCardHandle(card);
    if (!handle) return;
    if (tkImageDataCache.has(handle)) {
      tkImageDataCache.get(handle).then(function (data) {
        if (data) applyVariantImages(card, data);
      });
    } else {
      fetchVariantImagesOnce(card);
    }
  };

  function resolveAtcVariant(card, btn) {
    var selSw = card.querySelector('.tk-card-swatch.is-selected');
    var vid = null;
    var available = null;
    if (selSw) {
      vid = selSw.getAttribute('data-tk-variant-id');
      var availAttr = selSw.getAttribute('data-tk-variant-available');
      if (availAttr === 'false') available = false;
      else if (availAttr === 'true') available = true;
    }
    if (!vid) vid = card.getAttribute('data-tk-displayed-vid');
    if (!vid) vid = btn.getAttribute('data-variant-id');
    if (!vid) vid = card.getAttribute('data-selected-variant-id');
    return { vid: vid, available: available };
  }

  function showAtcToast(msg) {
    var old = document.querySelector('.quick-add-toast[data-tk-atc-toast]');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'quick-add-toast';
    t.setAttribute('data-tk-atc-toast', '1');
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.innerHTML = '<span class="quick-add-toast__icon" aria-hidden="true">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg></span>' +
      '<span class="quick-add-toast__text"></span>';
    t.querySelector('.quick-add-toast__text').textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('quick-add-toast--visible'); });
    setTimeout(function () {
      t.classList.remove('quick-add-toast--visible');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 350);
    }, 3200);
  }

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var sid = el.getAttribute('data-section-id');
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    });
    return ids;
  }

  function handleAtcClick(btn) {
    if (btn.disabled || btn.dataset.tkAtcLoading === '1') return;
    var card = btn.closest('product-card');
    if (!card) return;

    var resolved = resolveAtcVariant(card, btn);
    var variantId = resolved.vid;
    if (!variantId) return;
    if (resolved.available === false) {
      showAtcToast(btn.getAttribute('data-tk-soldout-text') || ((window.tkI18n && window.tkI18n.variant_sold_out) || 'This variant is sold out'));
      return;
    }

    btn.dataset.tkAtcLoading = '1';
    btn.classList.add('is-loading');

    var qty = 1;
    var productId = btn.getAttribute('data-product-id') || '';

    btn.dispatchEvent(new CustomEvent('cart:add:initiate', {
      bubbles: true,
      composed: true,
      detail: { quantity: qty },
    }));

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(qty));
    var sectionIds = getCartSectionIds();
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      })
      .then(function (res) {
        btn.dataset.tkAtcLoading = '';
        btn.classList.remove('is-loading');

        if (!res.ok || (res.body && res.body.status)) {
          btn.dispatchEvent(new CustomEvent('cart:add:revert', {
            bubbles: true,
            composed: true,
            detail: { quantity: qty },
          }));
          btn.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            composed: true,
            detail: {
              resource: {}, sourceId: card.id || '',
              data: { didError: true, source: 'tk-card-atc', itemCount: qty, productId: productId },
            },
          }));
          var msg = (res.body && (res.body.description || res.body.message)) || ((window.tkI18n && window.tkI18n.cart_add_error) || 'Error adding to cart');
          showAtcToast(msg);
          return;
        }

        var sections = (res.body && typeof res.body.sections === 'object' && res.body.sections) || {};

        btn.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          composed: true,
          detail: {
            resource: {}, sourceId: card.id || '',
            data: {
              sections: sections,
              source: 'product-form-component',
              itemCount: qty,
              productId: productId,
            },
          },
        }));

        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
      })
      .catch(function (err) {
        btn.dataset.tkAtcLoading = '';
        btn.classList.remove('is-loading');
        btn.dispatchEvent(new CustomEvent('cart:add:revert', {
          bubbles: true,
          composed: true,
          detail: { quantity: qty },
        }));
        btn.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          composed: true,
          detail: {
            resource: {}, sourceId: card.id || '',
            data: { didError: true, source: 'tk-card-atc', itemCount: qty, productId: productId },
          },
        }));
        showAtcToast(((window.tkI18n && window.tkI18n.cart_add_error) || 'Error adding to cart'));
        if (window.console) console.error('[tk-card-atc] add failed', err);
      });
  }

  function initAtcClicks() {
    if (window.__tkCardAtcInit) return;
    window.__tkCardAtcInit = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-tk-card-atc]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      handleAtcClick(btn);
    }, true);
  }

  function stripSoldOutAddedSpan() {
    document.querySelectorAll('.quick-add__button[disabled] .add-to-cart-text--added').forEach(function (el) {
      el.remove();
    });
  }

  function relocateAtcButton() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.getAttribute('data-tk-atc-relocated') === '1') return;

      var priceEl = card.querySelector('product-price');
      if (!priceEl) return;

      var existingRow = card.querySelector('.tk-card-bottom-row');

      if (!existingRow) {
        var row = document.createElement('div');
        row.className = 'tk-card-bottom-row';
        var leftCol = document.createElement('div');
        leftCol.className = 'tk-card-bottom-row__left';
        var rightCol = document.createElement('div');
        rightCol.className = 'tk-card-bottom-row__right';
        row.appendChild(leftCol);
        row.appendChild(rightCol);

        var parent = priceEl.parentNode;
        parent.insertBefore(row, priceEl);
        var prev = row.previousElementSibling;
        while (prev && prev.classList && prev.classList.contains('tk-stock-badge')) {
          var stale = prev;
          prev = prev.previousElementSibling;
          leftCol.appendChild(stale);
        }
        leftCol.appendChild(priceEl);
        existingRow = row;
      }

      var rightTarget = existingRow.querySelector('.tk-card-bottom-row__right');
      if (!rightTarget) return;

      if (rightTarget.querySelector('quick-add-component')) {
        card.querySelectorAll('.card-gallery quick-add-component').forEach(function (q) {
          if (q.parentNode) q.parentNode.removeChild(q);
        });
      } else {
        var quickAdd = card.querySelector('quick-add-component');
        if (quickAdd && !rightTarget.contains(quickAdd)) {
          rightTarget.appendChild(quickAdd);
        }
      }
      var tkAtc = card.querySelector('.tk-card-atc');
      if (tkAtc && !rightTarget.contains(tkAtc)) {
        rightTarget.appendChild(tkAtc);
      }

      var nativeSwatches = card.querySelector('product-swatches');
      if (nativeSwatches && existingRow.parentNode) {
        var afterRow = existingRow.nextElementSibling === nativeSwatches;
        if (afterRow || !existingRow.parentNode.contains(nativeSwatches) || existingRow.compareDocumentPosition(nativeSwatches) & Node.DOCUMENT_POSITION_FOLLOWING) {
          existingRow.parentNode.insertBefore(nativeSwatches, existingRow);
        }
      }

      card.setAttribute('data-tk-atc-relocated', '1');
    });
  }

  function ensureImgRetry(img) {
    if (!img || img._tkImgRetryHooked) return;
    img._tkImgRetryHooked = true;

    if (!img.complete || img.naturalWidth === 0) {
      img.classList.add('tk-img-fade');
      var reveal = function () { img.classList.add('tk-img-in'); };
      img.addEventListener('load', reveal, { once: true });
      img.addEventListener('error', reveal, { once: true });
      setTimeout(reveal, 1200);
    }

    img.addEventListener('error', function () {
      if (img._tkImgRetried) return;
      img._tkImgRetried = true;
      var origSrc = img.getAttribute('src');
      if (!origSrc) return;
      setTimeout(function () {
        img.removeAttribute('src');
        void img.offsetWidth;
        img.setAttribute('src', origSrc);
      }, 400);
    });
  }

  function forceLoadCardImages(card) {
    if (!card) return;
    card.querySelectorAll('img.product-media__image').forEach(function (img) {
      ensureImgRetry(img);
      if (img.complete && img.naturalWidth > 0) return;
      if (img.loading === 'lazy') img.loading = 'eager';
      var src = img.getAttribute('src');
      if (src && (!img.complete || img.naturalWidth === 0)) {
        if (!img._tkImgForceTried) {
          img._tkImgForceTried = true;
          img.removeAttribute('src');
          void img.offsetWidth;
          img.setAttribute('src', src);
        }
      }
    });
  }

  var tkImgIO = null;
  function getImgIO() {
    if (tkImgIO) return tkImgIO;
    if (typeof IntersectionObserver === 'undefined') return null;
    tkImgIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          forceLoadCardImages(entry.target);
          tkImgIO.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px' });
    return tkImgIO;
  }

  function initImageRetry() {
    var io = getImgIO();
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card._tkImgRetryQueued) return;
      card._tkImgRetryQueued = true;
      card.querySelectorAll('img.product-media__image').forEach(ensureImgRetry);
      if (io) io.observe(card);
      else forceLoadCardImages(card);
    });

    if (window.__tkImgSweepDone) return;
    window.__tkImgSweepDone = true;
    function sweep() {
      document.querySelectorAll('product-card img.product-media__image').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) return;
        if (img.loading === 'lazy') img.loading = 'eager';
        var src = img.getAttribute('src');
        if (src && !img._tkImgForceTried) {
          img._tkImgForceTried = true;
          img.removeAttribute('src');
          void img.offsetWidth;
          img.setAttribute('src', src);
        }
      });
    }
    setTimeout(sweep, 300);
    setTimeout(sweep, 1500);
  }

  function reorderSoldOutToEnd() {
    document.querySelectorAll('.tk-product-carousel__track').forEach(function (track) {
      if (track.getAttribute('data-tk-soldout-reordered') === '1') return;
      var items = Array.prototype.slice.call(track.querySelectorAll(':scope > .tk-product-carousel__item'));
      if (!items.length) return;
      function isSoldOut(item) {
        var card = item.querySelector('product-card[data-tk-available]');
        return card && card.getAttribute('data-tk-available') === 'false';
      }
      var soldOut = items.filter(isSoldOut);
      if (!soldOut.length) {
        track.setAttribute('data-tk-soldout-reordered', '1');
        return;
      }
      var seenSoldOut = false;
      var needsReorder = false;
      for (var i = 0; i < items.length; i++) {
        if (isSoldOut(items[i])) {
          seenSoldOut = true;
        } else if (seenSoldOut) {
          needsReorder = true;
          break;
        }
      }
      if (needsReorder) {
        soldOut.forEach(function (item) { track.appendChild(item); });
      }
      track.setAttribute('data-tk-soldout-reordered', '1');
    });
  }

  function initAll() {
    ingestEmbeddedSwatchData();
    initVariantSwapFix();
    initBadgeUpdate();
    initSwatchClicks();
    initSwatchHover();
    initAtcClicks();
    initDiscountPillClicks();
    openCartDrawerFromFlag();
    stripSoldOutAddedSpan();
    relocateAtcButton();
    reorderSoldOutToEnd();
    initImageRetry();
    initSwatchImgFadeIn();
  }

  function initSwatchImgFadeIn() {
    document.querySelectorAll('.tk-card-swatch img').forEach(function (img) {
      if (img._tkImgLoadHooked || img.classList.contains('is-loaded')) return;
      img._tkImgLoadHooked = true;
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
        return;
      }
      img.addEventListener('load', function () { this.classList.add('is-loaded'); var tksw = this.closest('.tk-card-swatch'); if (tksw) tksw.classList.add('tk-card-swatch--loaded'); }, { once: true });
      img.addEventListener('error', function () { this.classList.add('is-loaded'); var tksw = this.closest('.tk-card-swatch'); if (tksw) tksw.classList.add('tk-card-swatch--loaded'); }, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var target = document.getElementById('ResultsList') || document.getElementById('MainContent');
  if (target) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(initAll, 200);
    }).observe(target, { childList: true, subtree: true });

    var fastInject = function (node) {
      if (node.nodeType !== 1) return;
      var cards;
      if (node.matches && node.matches('product-card.product-card')) cards = [node];
      else if (node.querySelectorAll) cards = node.querySelectorAll('product-card.product-card');
      else return;
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        if (card._tkImagesQueued) continue;
        card._tkImagesQueued = true;
        fetchVariantImagesOnce(card);
      }
    };
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) fastInject(added[j]);
      }
    }).observe(target, { childList: true, subtree: true });
  }
})();

(function () {
  'use strict';

  function isSoldOutItem(li) {
    var card = li.querySelector('product-card[data-tk-available]');
    return !!card && card.getAttribute('data-tk-available') === 'false';
  }

  function isGridItem(node) {
    return node && node.nodeType === 1 && node.matches &&
      node.matches('li.product-grid__item') &&
      !!node.closest('results-list');
  }

  function demoteItems(grid, items) {
    var soldOut = [];
    for (var i = 0; i < items.length; i++) {
      if (isSoldOutItem(items[i])) soldOut.push(items[i]);
    }
    if (!soldOut.length) return false;
    var allItems = Array.prototype.slice.call(grid.children).filter(function (n) {
      return n.nodeType === 1 && n.classList.contains('product-grid__item');
    });
    var lastAvailIdx = -1;
    var firstSoldIdx = Infinity;
    for (var k = 0; k < allItems.length; k++) {
      var inScope = items.indexOf(allItems[k]) !== -1;
      if (!inScope) continue;
      if (soldOut.indexOf(allItems[k]) !== -1) {
        if (k < firstSoldIdx) firstSoldIdx = k;
      } else if (k > lastAvailIdx) {
        lastAvailIdx = k;
      }
    }
    if (firstSoldIdx > lastAvailIdx) return false;
    for (var j = 0; j < soldOut.length; j++) {
      grid.appendChild(soldOut[j]);
    }
    return true;
  }

  function demoteAll(grid) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > li.product-grid__item'));
    if (!items.length) return;
    demoteItems(grid, items);
  }

  function demoteAllGrids() {
    document.querySelectorAll('results-list ul.product-grid').forEach(demoteAll);
  }

  demoteAllGrids();
  if (window.requestAnimationFrame) {
    window.requestAnimationFrame(demoteAllGrids);
  }

  document.querySelectorAll('results-list').forEach(function (list) {
    var observer = new MutationObserver(function (records) {
      var addedItems = [];
      var replaced = false;
      for (var i = 0; i < records.length; i++) {
        var rec = records[i];
        if (rec.type !== 'childList') continue;
        var r, a;
        for (r = 0; r < rec.removedNodes.length; r++) {
          var rn = rec.removedNodes[r];
          if (rn.nodeType === 1 && rn.matches && rn.matches('li.product-grid__item')) {
            replaced = true;
          }
        }
        for (a = 0; a < rec.addedNodes.length; a++) {
          var an = rec.addedNodes[a];
          if (an.nodeType !== 1) continue;
          if (isGridItem(an)) {
            addedItems.push(an);
          } else if (an.matches && (an.matches('ul.product-grid') || an.matches('product-card') || (an.querySelector && an.querySelector('ul.product-grid, product-card')))) {
            replaced = true;
          }
        }
      }
      if (!replaced && !addedItems.length) return;
      if (replaced) {
        list.querySelectorAll('ul.product-grid').forEach(demoteAll);
      } else {
        var byGrid = new Map();
        for (var m = 0; m < addedItems.length; m++) {
          var li = addedItems[m];
          if (!li.isConnected) continue;
          var grid = li.parentElement;
          if (!grid || !grid.matches('ul.product-grid')) continue;
          if (!byGrid.has(grid)) byGrid.set(grid, []);
          byGrid.get(grid).push(li);
        }
        byGrid.forEach(function (items, grid) {
          items.sort(function (x, y) {
            return (x.compareDocumentPosition(y) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
          });
          demoteItems(grid, items);
        });
      }
      observer.takeRecords();
    });
    observer.observe(list, { childList: true, subtree: true });
  });
})();
